import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=2939cb28"
import script from "../../controllers/chat/request-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/chat/request-list.js?vue&type=script&lang=js&external"
import style0 from "./RequestList.vue?vue&type=style&index=0&id=2939cb28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports